import React from "react";
import { SelectList } from "web-ui";

import {
  getDuolingoTtsRecordedVoices,
  getDuolingoTtsVoiceNames,
} from "../api/duolingoTts";
import styles from "../styles/VoicePicker.module.scss";

export const VoicePicker = ({
  selectedLanguage,
  onChange,
  selectedVoice,
}: {
  selectedLanguage: string;
  onChange: (voice: string) => void;
  selectedVoice: string;
}) => {
  const [voices, setVoices] = React.useState<string[]>([]);
  const [voiceLabel, setVoiceLabel] = React.useState<string>("");
  const recordedVoicesRef = React.useRef<string[]>();

  React.useEffect(() => {
    (async () => {
      let newVoices;
      if (selectedLanguage) {
        newVoices = await getDuolingoTtsVoiceNames(selectedLanguage);
      } else {
        newVoices = await getDuolingoTtsVoiceNames();
      }
      if (newVoices) {
        setVoices(newVoices);
      }
    })();
    setVoiceLabel(`${selectedLanguage ? `${selectedLanguage}` : "all"} voices`);
  }, [selectedLanguage]);

  React.useEffect(() => {
    (async () => {
      const recordedVoices = await getDuolingoTtsRecordedVoices();
      recordedVoicesRef.current = recordedVoices?.map(voice => voice.name);
    })();
  }, []);

  // We need to indicate which voices are recorded because recorded voices are not logged in the tts-requeset-parameters db, and thus will not have results in the query.
  const recordedTaggedVoices = voices.map(voice =>
    recordedVoicesRef.current?.includes(voice) ? `${voice} (REC)` : voice,
  );

  return (
    <div>
      <SelectList
        className={styles["dropdown-selector"]}
        items={recordedTaggedVoices.map(voice => ({ text: voice }))}
        onChange={e =>
          onChange(recordedTaggedVoices[e.selectedIndices[0]] ?? "")
        }
        popoverPosition={{
          direction: "down",
          manualPositioning: true,
          style: {
            marginTop: 50,
            maxHeight: 426,
            position: "absolute",
          },
          zIndex: 100,
        }}
        selectedIndices={
          selectedVoice ? [recordedTaggedVoices.indexOf(selectedVoice)] : []
        }
        showSearch={true}
        text={selectedVoice ? selectedVoice : voiceLabel}
      />
    </div>
  );
};
